import * as d3 from 'd3'

// 縮放處理類
export class ZoomHandler {
  constructor (svg, g, iconLayer) {
    this.svg = svg
    this.g = g
    this.iconLayer = iconLayer
  }

  // 創建縮放行為
  createZoomBehavior (initialTransform) {
    const zoom = d3.zoom()
      .scaleExtent([0.5, 15])
      .on('zoom', (event) => {
        this.g.attr('transform', event.transform)

        // 根據縮放比例調整圖標大小
        this.iconLayer.selectAll('image')
          .attr('width', Math.min(4, Math.max(1, 1 * event.transform.k))) // 最小1px，最大5px
          .attr('height', Math.min(4, Math.max(1, 1 * event.transform.k)))

        this.iconLayer.selectAll('circle.progress-bg, circle.progress-ring')
          .attr('r', Math.min(2, Math.max(0.5, 0.5 * event.transform.k)))
          .attr('stroke-width', Math.min(1.25, Math.max(0.25, 0.25 * event.transform.k)))

        // 根據縮放比例調整案場標籤大小
        this.iconLayer.selectAll('.site-label-group .label-text')
          .attr('font-size', Math.min(0.8, Math.max(0.3, 0.5 * event.transform.k)))

        this.iconLayer.selectAll('.site-label-group .label-background')
          .attr('width', (d, i, nodes) => {
            const currentWidth = parseFloat(d3.select(nodes[i]).attr('width'))
            const scaledWidth = isNaN(currentWidth) ? 2 : currentWidth * event.transform.k
            return Math.min(4, Math.max(1.5, scaledWidth))
          })
          .attr('height', (d, i, nodes) => {
            const currentHeight = parseFloat(d3.select(nodes[i]).attr('height'))
            const scaledHeight = isNaN(currentHeight) ? 1 : currentHeight * event.transform.k
            return Math.min(1.5, Math.max(0.8, scaledHeight))
          })

        this.iconLayer.selectAll('.site-label-group .label-connector')
          .attr('stroke-width', Math.min(2, Math.max(0.5, 1 * event.transform.k)))
      })

    // 將 zoom 行為綁定到 svg 元素上
    this.svg.call(zoom)
      .call(zoom.transform, initialTransform)

    return zoom
  }

  // 聚焦到縣市
  focusOnCounty (d, path, width, height, zoom) {
    const [[x0, y0], [x1, y1]] = path.bounds(d)

    const scale = Math.min(8, 0.9 / Math.max((x1 - x0) / width, (y1 - y0) / height))
    const translateX = width / 2 - scale * (x0 + x1) / 2
    const translateY = height / 2 - scale * (y0 + y1) / 2
    const newTransform = d3.zoomIdentity.translate(translateX, translateY).scale(scale)

    // 直接使用 D3 transition 進行縮放聚焦（確保功能正常）
    this.svg.transition()
      .duration(300)
      .ease(d3.easeCubicOut)
      .call(zoom.transform, newTransform)
  }

  // 重置縮放到初始狀態
  resetZoom (zoom, initialTransform) {
    // 直接使用 D3 transition 重置縮放（確保功能正常）
    this.svg.transition()
      .duration(300)
      .ease(d3.easeCubicOut)
      .call(zoom.transform, initialTransform)
  }
}
